import { CaseAssignmentsReport } from "@/components/features/reports/CaseAssignments/CaseAssignmentsReport";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { caseAssignmentsQueryOptions } from "@/lib/data/react-query/reports/reports-case-assignments";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import type { CaseAssignmentsFilters } from "@/lib/data/requests/reports/reports-case-assignments";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { format, subDays } from "date-fns";
import { useState } from "react";

export const Route = createFileRoute("/_auth/reports/case-assignments")({
  component: RouteComponent,
});
function defaultFilters(): CaseAssignmentsFilters {
  return {
    startDate: format(subDays(new Date(), 6), "yyyy-MM-dd"),
    endDate: format(new Date(), "yyyy-MM-dd"),
    pageNumber: 1,
    pageSize: 25,
  };
}
function RouteComponent() {
  const { hasPagePermission } = useUser();
  const canView =
    hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsRoleAssignments) &&
    hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsSettlements);
  const [filters, setFilters] = useState(defaultFilters);
  const query = useQuery({
    ...caseAssignmentsQueryOptions(filters),
    enabled: canView && filters.startDate <= filters.endDate,
  });
  if (!canView) return <GlobalNotAuthorized />;
  return (
    <CaseAssignmentsReport
      filters={filters}
      report={query.data}
      isLoading={query.isLoading}
      isFetching={query.isFetching}
      isError={query.isError}
      onFilters={setFilters}
      onReset={() => {
        setFilters(defaultFilters());
      }}
      onRefresh={() => {
        void query.refetch();
      }}
    />
  );
}
